/**
 * Created by yibrahim on 20/07/2017.
 */
import {AuditableBaseResult} from './auditable-base-result';
import {BrokenRule} from './broken-rule';

export class AuditableResult<T> extends AuditableBaseResult {
  public value: T;

  constructor(value: T, brokenRules: Array<BrokenRule> = null) {
    super(brokenRules)
    this.value = value;
  }

  static parseAuditableResult (json: Object, valueParser: (json: Object) => any) {
    let baseResult = super.parseActionResult(json);
    let value = valueParser(json);
    return new AuditableResult(value, baseResult.brokenRules);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/auditable-result.ts